/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GtoStyle, GtoUom } from '@gh/builder-shared-data';
import { rendererColorCircle, rendererCrossedCircle, ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { EnumDictionary, getRouteInitData, intColorToHexColor } from '@gh/common-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { assign } from 'lodash';
import { TakeOffParam } from '../../resources/estimating-take-off-params-tab.model';

@Injectable()
export class EstimatingTakeOffParamsTabGridDefinition extends LayoutBasedGridDefinition {

  gtoStyles: EnumDictionary<GtoStyle>;
  gtoUoms: EnumDictionary<GtoUom>;

  columnDefs = {
    gtoColor: {
      cellRenderer: ({ value }: any) => {
        if (value) {
          return rendererColorCircle(intColorToHexColor(value));
        }
        return rendererCrossedCircle();
      },
    },
    gtoStyle: {
      valueGetter: (params: any) => params.node.data.gtoStyle
        ? this.gtoStyles.get(params.node.data.gtoStyle)
        : '',
    },
    gtoUom: {
      valueGetter: (params: any) => params.node.data.gtoUom
        ? this.gtoUoms.get(params.node.data.gtoUom)
        : '',
    },
  };

  options = {
    getRowClass: ({ data }: { data: TakeOffParam }) => {
      if (data.isActive !== true) {
        return ROW_DELETED_CLASS;
      }
    },
    getRowNodeId: (data: TakeOffParam) => data.takeOffParamId,
  };

  constructor(private route: ActivatedRoute) {
    super();
    const { gtoStyles, gtoUoms } = getRouteInitData(route);
    assign(this, { gtoStyles, gtoUoms });
  }
}
